import { Injectable } from '@angular/core';
import { EntityType } from '@app/shared/enums/entity-type.enum';
import { ApiService } from './api.service';

@Injectable()
export class DetallesTarifarioService extends ApiService {
  entityType = EntityType.TARIFARIO;
  url = 'api/tarifarios-detalle/';
}
